import { 
  sendEmailVerification as sendAppEmailVerification,
  verifyBeforeUpdateEmail
} from '../staffAuthApi';
import { 
  auth, 
  actionCodeSettings, 
  emailRecoverySettings 
} from '../appAuth';
import { requestPasswordReset } from '../password-reset/passwordResetApi';

/**
 * Send a password reset email with custom action code settings
 * @param {string} email - The email address to send the password reset email to
 * @returns {Promise<void>}
 */
export const sendPasswordResetEmail = (email) => {
  return requestPasswordReset({ email });
};

/**
 * Send an email verification with custom action code settings
 * @param {Object} user - The user object to send the verification email to
 * @returns {Promise<void>}
 */
export const sendEmailVerification = (user) => {
  return sendAppEmailVerification(user, actionCodeSettings);
};

/**
 * Update a user's email address with verification
 * @param {Object} user - The user object to update the email for
 * @param {string} newEmail - The new email address
 * @returns {Promise<void>}
 */
export const updateEmailWithVerification = (user, newEmail) => {
  return verifyBeforeUpdateEmail(user, newEmail, emailRecoverySettings);
};

/**
 * Get URL parameters from the current URL
 * @param {string} name - The name of the parameter to get
 * @param {string} url - The URL to get the parameter from (defaults to window.location.href)
 * @returns {string|null} - The parameter value or null if not found
 */
export const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}; 